import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Affix, Button, Col, FormInstance, Row } from 'antd';
import styles from './styles.module.scss';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
interface KlwHeaderProps {
  title: ReactNode;
  isKlwReadOnly: boolean;
  form?: FormInstance<any>;
  saveButtonFunc?: () => void;
  isSaving: boolean;
  content?: ReactNode;
  btnDisabled?: boolean;
}
export const KlwSubHeader: FC<KlwHeaderProps> = ({ title, isKlwReadOnly, form, isSaving, saveButtonFunc, content, btnDisabled = false }) => {
  const rowStyle = classNames(['main', styles.row]);
  const divStyle = classNames(['buttons', 'text-right']);
  const btnStyle = classNames(['btn-transparent', styles.font16]);
  return (
    <>
      <Affix offsetTop={83}>
        <Row className={rowStyle}>
          <Col span={24}>
            <h1>{title}</h1>
          </Col>
          <Col span={20}>{content}</Col>
          <Col span={4}>
            <div className={divStyle}>
              {!isKlwReadOnly && (saveButtonFunc || form) && (
                <Button
                  shape="round"
                  type="primary"
                  disabled={btnDisabled || isSaving}
                  onClick={saveButtonFunc ? saveButtonFunc : form?.submit}
                  className={btnStyle}
                  loading={isSaving}>
                  Alles opslaan
                  <FontAwesomeIcon className={styles.icon} icon="save" />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Affix>
      <div className={styles.blockingDiv} />
    </>
  );
};

export default KlwSubHeader;
